<div [class]="cellContainerClass()">
  <div #cellContainer class="cell-value" [class.with-warning]="warningTooltipText()">
    @if (originalValue()?.length) {
      <div class="tags-container" [class.with-buttons]="buttons().length">
        @for (chip of params().value; track $index) {
          <ng-container
            [ngTemplateOutlet]="chipMainContent"
            [ngTemplateOutletContext]="{ chip }"
          ></ng-container>
        }
        @if (hiddenChipsNumber()) {
          <app-auto-open-menu #autoOpenMenu matMenuClass="hidden-chips" xPosition="after">
            <div trigger [class]="this.tagClass">
              +{{ originalValue().length - params().value.length }}
            </div>
            <div class="flex-column hidden-chips-container" content>
              @for (chip of hiddenChips(); track $index) {
                <ng-container
                  [ngTemplateOutlet]="chipMainContent"
                  [ngTemplateOutletContext]="{ chip }"
                ></ng-container>
              }
            </div>
          </app-auto-open-menu>
        }

        <ng-template #chipMainContent let-chip="chip">
          @if (hasLink) {
            <app-form-link
              (linkClick)="autoOpenMenu()?.closeMenu()"
              [class]="this.tagClass"
              [ngClass]="params()['classParam'] ? getChipClass(chip) : ''"
              [link]="getChipLink(chip)"
              [openInNewTab]="params()['openInNewTab'] ?? false"
            >
              <ng-container
                [ngTemplateOutlet]="chipContent"
                [ngTemplateOutletContext]="{ chip, chipText: getChipText(chip) }"
              ></ng-container>
            </app-form-link>
          } @else {
            <div
              [class]="this.tagClass"
              [ngClass]="params()['classParam'] ? getChipClass(chip) : ''"
            >
              <ng-container
                [ngTemplateOutlet]="chipContent"
                [ngTemplateOutletContext]="{ chip, chipText: getChipText(chip) }"
              ></ng-container>
            </div>
          }
        </ng-template>

        <ng-template #chipContent let-chip="chip" let-chipText="chipText">
          @if (params()["showIcon"] && params()["showIcon"](chip)) {
            <mat-icon [tpIsLazy]="true" [tp]="params()['iconTooltip'] ?? ''">
              {{ params()["icon"] }}
            </mat-icon>
          }
          <div
            class="text"
            [tpIsLazy]="true"
            [tp]="chipText?.length > MAX_CHIPS_TEXT_LENGTH_TO_SHOW ? chipText : ''"
          >
            {{ chipText }}
          </div>
        </ng-template>
      </div>
    } @else {
      -
    }
  </div>

  @if (warningTooltipText()) {
    <div class="cell-warning">
      <mat-icon
        class="suffix-icon error warn-icon"
        svgIcon="action_pending"
        [tp]="warningTooltipText()"
      ></mat-icon>
    </div>
  }

  <div class="cell-actions">
    @for (button of buttons(); track button) {
      @if (show(button)) {
        <app-button
          stopPropagation
          [tp]="tooltip(button)"
          [tpIsLazy]="true"
          [disabled]="isDisabled(button)"
          (pressed)="button.click && button.click(this.data(), $event)"
          type="icon"
        >
          @if (button.svgIcon) {
            <mat-icon [class]="iconClass(button)" icon-small [svgIcon]="button.svgIcon"></mat-icon>
          } @else {
            <mat-icon [class]="iconClass(button)" icon-small>{{ button.icon }}</mat-icon>
          }
        </app-button>
      }
    }
  </div>
</div>
